import { Fragment, h } from 'preact';
import './playbook.scss';
import { useEffect, useState } from 'preact/hooks';
import { DATA_EVENTS, EVENTS, EVENTS_TO_SDK, INTERNAL_EVENTS, SDK_EVENTS } from '../../../constants/events.cnst';
import fetchInstance from '../../../utils/interceptor';
import { getHTML } from '../../base/domManager';
import { ClassMapConstanst, IdMapConstant, PlaybookColorMap, ProjConstants } from '../../../constants/projConsts';
import { ERROR_CODES } from '../../../constants/errorcodes';

export function RenderEachStageItem(props: any) {
    return (
        <div>
            {props?.msgData?.stageList?.map((stage: any, stInx: any) => {
                let stageCompleted = (stage?.steps || []).every((item : any) => item.complete);
                const stageDrpClass = ['aa-dropdown-item', `aa-stage-drp-${stInx}`];
                if(stage.name === 'Close') stageDrpClass.push('aa-close-stage-btn');
                if(stage.name === 'Close' && !stageCompleted) stageDrpClass.push('disabled-msg');

                return (
                    <button aria-disabled="true" className={`${stageDrpClass.join(' ')}`}>
                        <p>{stage.name}</p>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" className={`aa-selected-stage-${stInx} ${stInx !== props.msgData?.selectedStInx ? 'aa-hidden' : ''}`}>
                            <path d="M15 4.5L6.75 12.75L3 9" stroke="#2970FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                )
            })
            }
        </div>
    )
}

export function RenderEachPrimaryChecklistItem(props: any) {
    const languageData = props?.hostInstance?.languagedata
    return (
        <div>
            {props?.msgData?.allChecklists?.map((cl: any, clInx: any) => {
                return (
                    <Fragment>
                        {clInx == 0 && <div className="heading-text-scripts aa-primary-scripts">{languageData?.PRIMARY_SCRIPTS}</div>}
                        {cl.type === 'primary' && <button aria-disabled="true" className={`aa-dropdown-item aa-primary-cl-${clInx}`}>
                            <p>{cl.name}</p>
                            <button className={`primaryBtn aa-hidden aa-cl-resume-${clInx}`}>{languageData?.RESUME}</button>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" className={`aa-cl-check-${clInx} aa-cl-item aa-hidden`}>
                                <path d="M15 4.5L6.75 12.75L3 9" stroke="#2970FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>}
                    </Fragment>
                )
            })}
        </div>
    )
}

export function RenderEachDynamicChecklistItem(props: any) {
    const languageData = props?.hostInstance?.languagedata
    return (
        <div>
            {props?.msgData?.allChecklists?.map((cl: any, clInx: any) => {
                return (
                    <Fragment>
                        {clInx == 0 && <div className="heading-text-scripts aa-dynamic-scripts">{languageData?.DYNAMIC_SCRIPTS}</div>}
                        {cl.type === 'dynamic' && <button aria-disabled="true" className={`aa-dropdown-item aa-dynamic-cl-${clInx}`}>
                            <p>{cl.name}</p>
                            <button className={`primaryBtn aa-hidden aa-cl-resume-${clInx}`}>{languageData?.RESUME}</button>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" className={`aa-cl-check-${clInx} aa-cl-item aa-hidden`}>
                                <path d="M15 4.5L6.75 12.75L3 9" stroke="#2970FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>}
                    </Fragment>
                )
            })}
        </div>
    )
}

export function RenderEachTriggeredChecklist(props: any) {
    return (
        <button aria-disabled="true" className={`aa-dropdown-item aa-trigger-checklist-btn-${props?.msgData?.checklist?._id}`}>
            <p className="aa-trigger-checklist-name">{props?.msgData?.checklist?.name}</p>
            <span className="aa-trigger-checklist-stepcount">{props?.msgData?.checklist?.stages?.length} {props?.hostInstance?.languagedata?.STEP}</span>
        </button>
    )
}

export function RenderEmptyPlaybookScreen(props: any) {
    return (
        <div className="empty-listing-triggers aa-checklist-empty">
            <h1 className="aa-text-sm medium">{props?.hostInstance?.languagedata?.NO_ACTIVE_PLAYBOOK}</h1>
        </div>
    )
}

export function RenderEmptyPlaybookMsg(props: any) {
    const languageData = props?.hostInstance?.languagedata
    return (
        <div className="empty-listing-triggers aa-checklist-empty">
            <h1 className="aa-text-sm medium">{languageData?.PLAYBOOK_EMPTY_MSG}</h1>
            <p className="aa-desc-xs center">{languageData?.PLAYBOOK_EMPTY_DESC}</p>
        </div>
    )
}

export function RenderPlaybookHeader(props: any) {
    const languageData = props?.hostInstance?.languagedata
    return (
        <div className="playbook-header-data aa-playbook-header">
            <div className="left-sec-data">
                <div className="aa-dropdown aa-triggerList-drp-wrapper aa-hidden">
                    <button type="button" id="playbookDrpTriggerChecklist" className="aa-dropdown-toggle playbook-suggestion aa-trigger-checklist-count-btn">
                        <sub className="aa-triggerDynChecklist-bulb-count"></sub>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M13.0496 4.64998C13.0496 4.07008 12.5795 3.59998 11.9996 3.59998C11.4197 3.59998 10.9496 4.07008 10.9496 4.64998V5.69998C10.9496 6.27987 11.4197 6.74998 11.9996 6.74998C12.5795 6.74998 13.0496 6.27987 13.0496 5.69998V4.64998Z" fill="#2B75E4" />
                            <path d="M17.9393 7.54515C18.3493 7.1351 18.3493 6.47027 17.9393 6.06022C17.5292 5.65017 16.8644 5.65017 16.4543 6.06022L15.7119 6.80269C15.3018 7.21274 15.3018 7.87756 15.7119 8.28761C16.1219 8.69766 16.7868 8.69766 17.1968 8.28761L17.9393 7.54515Z" fill="#2B75E4" />
                            <path d="M20.3996 12C20.3996 12.5799 19.9295 13.05 19.3496 13.05H18.2996C17.7197 13.05 17.2496 12.5799 17.2496 12C17.2496 11.4201 17.7197 10.95 18.2996 10.95H19.3496C19.9295 10.95 20.3996 11.4201 20.3996 12Z" fill="#2B75E4" />
                            <path d="M6.80231 8.28763C7.21236 8.69768 7.87718 8.69768 8.28723 8.28763C8.69728 7.87758 8.69728 7.21275 8.28723 6.8027L7.54477 6.06024C7.13472 5.65019 6.4699 5.65019 6.05984 6.06024C5.64979 6.47029 5.64979 7.13512 6.05984 7.54517L6.80231 8.28763Z" fill="#2B75E4" />
                            <path d="M6.74961 12C6.74961 12.5799 6.27951 13.05 5.69961 13.05H4.64961C4.06971 13.05 3.59961 12.5799 3.59961 12C3.59961 11.4201 4.06971 10.95 4.64961 10.95H5.69961C6.27951 10.95 6.74961 11.4201 6.74961 12Z" fill="#2B75E4" />
                            <path d="M9.89961 18.3V17.25H14.0996V18.3C14.0996 19.4598 13.1594 20.4 11.9996 20.4C10.8398 20.4 9.89961 19.4598 9.89961 18.3Z" fill="#2B75E4" />
                            <path d="M14.1005 16.2C14.1159 15.8426 14.3176 15.5214 14.6003 15.2982C15.5744 14.529 16.1996 13.3375 16.1996 12C16.1996 9.68038 14.3192 7.79998 11.9996 7.79998C9.68001 7.79998 7.79961 9.68038 7.79961 12C7.79961 13.3375 8.42483 14.529 9.39896 15.2982C9.68164 15.5214 9.88335 15.8426 9.89867 16.2H14.1005Z" fill="#2B75E4" />
                        </svg>
                    </button>
                    <div className="playbook-dropdown-content aa-dropdown-content aa-trigger-checklist-drp" aria-labelledby="playbookDrpTriggerChecklist">
                        <div className="heading-text-scripts">{languageData?.RECOMENDED_PLAYBOOK}</div>

                    </div>
                </div>
                <div className="dropdowns-text-info">
                    <div className="aa-dropdown aa-checklist-drp-wrapper aa-hidden">
                        <button type="button" id="playbookDrpListBtn" className="aa-dropdown-toggle">
                            <span className="aa-selected-checklist"></span>
                            <svg className="arrow-icon aa-selected-checklist-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.52876 5.52858C3.78911 5.26823 4.21122 5.26823 4.47157 5.52858L8.00016 9.05717L11.5288 5.52858C11.7891 5.26823 12.2112 5.26823 12.4716 5.52858C12.7319 5.78892 12.7319 6.21103 12.4716 6.47138L8.47157 10.4714C8.21122 10.7317 7.78911 10.7317 7.52876 10.4714L3.52876 6.47138C3.26841 6.21103 3.26841 5.78892 3.52876 5.52858Z" fill="#667085" />
                            </svg>
                        </button>
                        <div className="playbook-dropdown-content aa-dropdown-content aa-checklist-drp" aria-labelledby="playbookDrpListBtn">

                        </div>
                    </div>
                    <div className="bottom-titles-info aa-stage-drp-wrapper-main aa-hidden">
                        <h6>{languageData?.STAGE} : </h6>
                        <div className="aa-dropdown aa-stage-drp-wrapper">
                            <button type="button" id="playbookStageDrpBtn" className="aa-dropdown-toggle">
                                <span className="aa-selected-stage"></span>
                                <svg className="arrow-icon aa-selected-stage-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.52876 5.52858C3.78911 5.26823 4.21122 5.26823 4.47157 5.52858L8.00016 9.05717L11.5288 5.52858C11.7891 5.26823 12.2112 5.26823 12.4716 5.52858C12.7319 5.78892 12.7319 6.21103 12.4716 6.47138L8.47157 10.4714C8.21122 10.7317 7.78911 10.7317 7.52876 10.4714L3.52876 6.47138C3.26841 6.21103 3.26841 5.78892 3.52876 5.52858Z" fill="#667085" />
                                </svg>
                            </button>
                            <div className="playbook-dropdown-content aa-dropdown-content aa-stage-drp" aria-labelledby="playbookStageDrpBtn">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="actions-checklist-header">
                <button className="solid-action step-complete aa-step-complete-count aa-hidden" aria-label="button"></button>
                <button className="solid-action stop-assist aa-proceedtoclose-btn aa-hidden" aria-label="button" title={`${languageData?.PROCEED_TO_CLOSE}`}>
                    <svg width="13" height="12" viewBox="0 0 13 12" fill="none">
                        <g clip-path="url(#clip0_9531_17675)">
                            <path d="M8.24998 4V2.5L9.74998 1L10.25 2L11.25 2.5L9.74998 4H8.24998ZM8.24998 4L6.24999 5.99997M11.25 6C11.25 8.76142 9.01142 11 6.25 11C3.48858 11 1.25 8.76142 1.25 6C1.25 3.23858 3.48858 1 6.25 1M8.75 6C8.75 7.38071 7.63071 8.5 6.25 8.5C4.86929 8.5 3.75 7.38071 3.75 6C3.75 4.61929 4.86929 3.5 6.25 3.5" stroke="#DC2626" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="clip0_9531_17675">
                                <rect width="12" height="12" fill="white" transform="translate(0.25)" />
                            </clipPath>
                        </defs>
                    </svg>
                </button>
            </div>
        </div>
    )
}

export function RenderChecklistBody(props: any) {

    const rootServiceInstance = props?.msgData?.hostInstance?.rootService;

    const [hideActionButtons, setHideActionButtons] = useState(rootServiceInstance.hideActionButtons);
    const [hideSendButton, setHideSendButton] = useState(rootServiceInstance?.hideSendButton);
    const [hideCopyButton, setHideCopyButton] = useState(rootServiceInstance?.hideCopyButton);

    useEffect(() => {
    }, [])

    return (
        <div className="playbook-steps-repeat-data">
            {props?.msgData?.stages.map((stage: any, stInx: any) => {

                let stageCompleted = (stage?.steps || []).every((item : any) => item.complete);

                const stageClass = ['close-playbook-data', `aa-playbook-stage-${stInx}`];
                if (stage.name === 'Close') stageClass.push('aa-close-stage');
                if (!stageCompleted) stageClass.push('aa-hidden');
                                
                return (
                    <Fragment key={stInx}>
                        {stInx != 0 && <div className={`${stageClass.join(' ')}`}>
                            <span></span>
                            <p>{stage.name}</p>
                            <span></span>
                        </div>}

                        {stage?.steps?.map((step: any, stepInx: any) => {

                        const stepClass = ['playbook-step', `aa-playbook-step-${stInx}-${stepInx} `];
                        if (stage.name === 'Close') stepClass.push('aa-close-steps');
                        if (step?.ongoing) stepClass.push('playbook-step-ongoing');
                        if (stage.name === 'Close' && !stageCompleted) stepClass.push('aa-hidden');

                            return (
                                <button key={stepInx} className={`${stepClass.join(' ')}`} id={`${step._id}`}>
                                    <div className={`heading-step aa-heading-step ${step?.ongoing ? '' : 'disabled-msg'}`}>
                                        <h1 className={`aa-step-header-name ${step.complete ? 'strike-text' : ''}`}>{step.name}</h1>
                                        <button className={`check-btn aa-step-complete-${stInx}-${stepInx} ${step?.ongoing ? '' : 'aa-hidden'}`}>
                                            <svg width="10" height="10" viewBox="0 0 7 6" fill="none">
                                                <path d="M6.34755 0.999929C6.67364 1.32601 6.67365 1.85471 6.34756 2.1808L4.79202 3.73638L3.23648 5.29196C3.07989 5.44856 2.8675 5.53653 2.64604 5.53653C2.42458 5.53653 2.21219 5.44855 2.0556 5.29196L0.50005 3.73636C0.173967 3.41026 0.173975 2.88157 0.500069 2.55549C0.826161 2.2294 1.35485 2.22941 1.68094 2.55551L2.64605 3.52065L5.16668 0.999945C5.49276 0.673852 6.02146 0.673846 6.34755 0.999929Z" fill="#D4D4D4" />
                                            </svg>
                                        </button>
                                    </div>
                                    <div className={`step-text-send-block ${step.ongoing ? '' : 'aa-hidden'}`}>
                                        <div className={`step-actions-send-copy ${!hideActionButtons ? '' : 'aa-hidden'}`}>
                                            <button className={`solidbtn aa-step-copy-btn ${!hideCopyButton && step?.isSendCopy ? '' : 'aa-hidden'}`}>
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <g clip-path="url(#clip0_9531_13889)">
                                                        <path d="M10.6663 10.6667V12.5333C10.6663 13.2801 10.6663 13.6534 10.521 13.9387C10.3932 14.1895 10.1892 14.3935 9.93833 14.5214C9.65311 14.6667 9.27974 14.6667 8.53301 14.6667H3.46634C2.7196 14.6667 2.34624 14.6667 2.06102 14.5214C1.81014 14.3935 1.60616 14.1895 1.47833 13.9387C1.33301 13.6534 1.33301 13.2801 1.33301 12.5333V7.46668C1.33301 6.71994 1.33301 6.34657 1.47833 6.06136C1.60616 5.81047 1.81014 5.6065 2.06102 5.47867C2.34624 5.33334 2.7196 5.33334 3.46634 5.33334H5.33301M7.46634 10.6667H12.533C13.2797 10.6667 13.6531 10.6667 13.9383 10.5214C14.1892 10.3935 14.3932 10.1895 14.521 9.93866C14.6663 9.65345 14.6663 9.28008 14.6663 8.53334V3.46668C14.6663 2.71994 14.6663 2.34657 14.521 2.06136C14.3932 1.81047 14.1892 1.6065 13.9383 1.47867C13.6531 1.33334 13.2797 1.33334 12.533 1.33334H7.46634C6.7196 1.33334 6.34624 1.33334 6.06102 1.47867C5.81014 1.6065 5.60616 1.81047 5.47833 2.06136C5.33301 2.34657 5.33301 2.71994 5.33301 3.46668V8.53334C5.33301 9.28008 5.33301 9.65345 5.47833 9.93866C5.60616 10.1895 5.81014 10.3935 6.06102 10.5214C6.34624 10.6667 6.7196 10.6667 7.46634 10.6667Z" stroke="#101828" stroke-linecap="round" stroke-linejoin="round" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_9531_13889">
                                                            <rect width="16" height="16" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </button>
                                            <button className={`solidbtn aa-step-send-btn ${!hideSendButton && step?.isSendCopy ? '' : 'aa-hidden'}`}>{props?.hostInstance?.languagedata?.SEND}</button>
                                        </div>
                                        <p>{step.description}</p>
                                        <div className={`border-bottom-pad ${step?.confirmButtons?.length > 0 ? '' : 'aa-hidden'}`}>
                                            <div className="bottom-data-info">
                                                <h1></h1>
                                                <div className="right-info-data">
                                                    {step?.confirmButtons?.map((btn: any, btnInx: any) => {
                                                        const buttonStyle = {
                                                            backgroundColor: props?.msgData?.colors[btn.color],
                                                            color: btn.color
                                                        };
                                                        return (
                                                            <button className={`_btn primaryBtn aa-step-confirmation-btn-${btnInx}`} style={buttonStyle}>{btn.title}</button>
                                                        )
                                                    })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            )
                        }
                        )}
                    </Fragment>
                )
            })}
        </div>
    )
}

export function Playbook({ hostInstance }: any) {

    const [allCheckListsData, setAllCheckListData] = useState<any>({});
    const [triggeredDynCheckLists, setTriggeredDynCheckLists] = useState<any>([]);

    const rootServiceInstance = hostInstance.rootService;
    const languageData = hostInstance?.languagedata;

    // clicking outside hide dropdown content (checklist, stage).
    const handleDropdownClickEvent = () => {
        window.onclick = function(event : any) {            
            if (!event.target.matches('aa-stage-drp-wrapper')) {
                rootServiceInstance.hideDropdownTemplate('aa-stage-drp-wrapper', hostInstance);
            } 
            if(!event.target.matches('aa-checklist-drp-wrapper')){
                rootServiceInstance.hideDropdownTemplate('aa-checklist-drp-wrapper', hostInstance);
            }
            if(!event.target.matches('aa-triggerList-drp-wrapper')){
                rootServiceInstance.hideDropdownTemplate('aa-triggerList-drp-wrapper', hostInstance);
            }
        }
    }

    useEffect(() => {        
        let triggerDropdownWrapperEle = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.TRIGGER_CHECKLIST_DROPDOWN_WRAPPER}`)
        if(triggeredDynCheckLists?.length > 0){
            triggerDropdownWrapperEle?.classList?.remove(ClassMapConstanst.HIDE_ELEMENT);
        }else {
            triggerDropdownWrapperEle?.classList?.add(ClassMapConstanst.HIDE_ELEMENT);
        }
        updateTriggerChecklistCount(triggeredDynCheckLists);
    }, triggeredDynCheckLists)

    useEffect(() => {


        const handleGetChecklistsData = ((flag : boolean) => {
            if(flag){
                getAllChecklists();
            }
        })

        const handleChecklistResponse = (checklistResponse: any) => {
            if (checklistResponse && checklistResponse.checklistsIdentified) {
                (checklistResponse.checklistsIdentified || []).forEach((item: any) => {
                    let id = (item.checklistId || item.id || item._id);
                    setTriggeredDynCheckLists((prevTriggeredDynChecklists: any) => {
                        let inx = prevTriggeredDynChecklists.findIndex((cl: any) => cl._id === id);
                        if (inx < 0) {
                            if (rootServiceInstance.dynClObjs[id]) {
                                addTriggerChecklistItem(rootServiceInstance.dynClObjs[id], prevTriggeredDynChecklists?.length);
                                let triggeredDynCheckLists = [...prevTriggeredDynChecklists, (JSON.parse(JSON.stringify(rootServiceInstance.dynClObjs[id])))];
                                return triggeredDynCheckLists;
                            }
                        }
                        return prevTriggeredDynChecklists;
                    })
                })
            }
        }

        const handleChecklistStepResponse = (checklistStepResponse: any) => {
            setAllCheckListData((prevCheckListsData: any) => {
                let clObj = checklistStepResponse?.checklistStepsIdentified;
                (clObj || [])
                    .forEach((item: any) => {
                        let stage : any = {};
                        let step = {};
                        let clInx = prevCheckListsData.checklists.findIndex((cl: any) => cl._id === item.id);
                        let stInx = (prevCheckListsData.checklists[clInx].stages || []).findIndex((s: any) => {
                            if (s._id === item.stageId) {
                                stage = s;
                                return true;
                            }
                        });
                        let stepInx = (prevCheckListsData.checklists[clInx].stages[stInx].steps || []).findIndex((st: any) => {
                            if (st._id === item.stepId) {
                                step = st;
                                return true;
                            }
                        });
                        if(stage.name === 'Close' && !rootServiceInstance.isProceedToClose){
                            let proceedToCloseBtn = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.PROCEEDTOCLOSE_BTN}`);
                            handleCloseStage(false, proceedToCloseBtn);
                        }
                        stepComplete(prevCheckListsData, stage, step, clInx, stInx, stepInx);
                    })
                return prevCheckListsData;
            })
        }

        hostInstance.on(INTERNAL_EVENTS.GET_CHECKLISTS, handleGetChecklistsData);
        hostInstance.on(DATA_EVENTS.CHECKLIST_RESPONSE, handleChecklistResponse);
        hostInstance.on(DATA_EVENTS.CHECKLIST_STEP_RESPONSE, handleChecklistStepResponse);

        handleDropdownClickEvent();

        subscribeEvents();

        handleGetChecklistsData(true);

        return () => {
            hostInstance.off(INTERNAL_EVENTS.GET_CHECKLISTS, handleGetChecklistsData);
            hostInstance.off(DATA_EVENTS.CHECKLIST_RESPONSE, handleChecklistResponse);
            hostInstance.off(DATA_EVENTS.CHECKLIST_STEP_RESPONSE, handleChecklistStepResponse);
        };
    }, []);

    const subscribeEvents = () => {
        hostInstance.on(EVENTS_TO_SDK.CHECKLIST_OPEN, (data : any) => {
            emitEvents(EVENTS.checklist_opened, data, SDK_EVENTS.PLAYBOOK_OPENED_EVENT);
        });

        hostInstance.on(EVENTS_TO_SDK.CHECLIST_RESUME, (data : any) => {
            emitEvents(EVENTS.checklist_resume, data, SDK_EVENTS.PLAYBOOK_RESUME_EVENT);
        });

        hostInstance.on(EVENTS_TO_SDK.CHECKLIST_STEP_CLOSE, (data : any) => {
            emitEvents(EVENTS.checklist_step_closed, data, SDK_EVENTS.PLAYBOOK_STEP_CLOSED_EVENT);
        });

        hostInstance.on(EVENTS_TO_SDK.CHECKLIST_PROCEED_TO_CLOSE, (data : any) => {
            emitEvents(EVENTS.checklist_proceed_to_closed, data, SDK_EVENTS.PLAYBOOK_PROCEED_TO_CLOSE_EVENT);
        });
    }

    const emitEvents = (eventName : string, checklistParams : any, sdkEventName : string) => {
        hostInstance.socketConnection.emitEvents(eventName, checklistParams);
        hostInstance.emit(sdkEventName, checklistParams);
    }

    const getChecklistData = () => {
        const { botId } = rootServiceInstance.connectionDetails
        return fetchInstance('get_checklist', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }, hostInstance, { botId });
    }

    const getAllChecklists = () => {
        getChecklistData()
            .then((data) => {
                if (data?.checklists?.length > 0) {
                    data.checklists = data.checklists.filter((check : any) => check.channels.includes(rootServiceInstance.connectionDetails.channel));

                    let dynamicClList = data.checklists.filter((check: any) => check.type === "dynamic");
                    let primaryClList = data.checklists.filter((check: any) => check.type === "primary");

                    setAllCheckListData(data);

                    prepareCheckListHeader(data, primaryClList, dynamicClList);

                    rootServiceInstance.dynClObjs = (dynamicClList || [])
                        .reduce((acc: any, item: any) => {
                            acc[item._id] = item;
                            return acc;
                        }, {});

                    sendOpenCheckListEvent(primaryClList, dynamicClList);
                }else{
                    let bodyTemplate = hostInstance?.chatEle?.querySelector(`#${IdMapConstant.CHECKLIST_BODY_TEMPLATE}`);
                    let emptyPlaybookScreen = getHTML(RenderEmptyPlaybookScreen, { hostInstance: hostInstance }, hostInstance);
                    if (bodyTemplate) {
                        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, emptyPlaybookScreen, { event: SDK_EVENTS.PLAYBOOK_EMPTY_SCREEN,  data : {}});
                        bodyTemplate.append(emptyPlaybookScreen);
                    }
                }
            })
            .catch((err: any) => {
                hostInstance.emit(SDK_EVENTS.ON_ERROR, ERROR_CODES['ERR_CHECKLIST_API_FAILURE']);
            });
    }

    // empty msg if primary checklist not present.
    const checkAndHideEmptyMsg = () => {
        let checkListEmptyEle = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.CHECKLIST_EMPTY}`);
        if (!checkListEmptyEle?.classList?.contains(ClassMapConstanst.HIDE_ELEMENT)) {
            checkListEmptyEle?.classList?.add(ClassMapConstanst.HIDE_ELEMENT);
        }
    }

    // preparing header template of playbook.
    const prepareCheckListHeader = (prevCheckListsData: any, primaryChecklist: any, dynamicChecklist: any) => {
        let checklistHeaderEle: any = getHTML(RenderPlaybookHeader, { hostInstance: hostInstance, checklistData: prevCheckListsData }, hostInstance);

        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, checklistHeaderEle, { event: SDK_EVENTS.PLAYBOOK_HEADER_TEMPLATE,  data : {checklists : prevCheckListsData.checklists}});

        hostInstance?.chatEle?.querySelector(`#${IdMapConstant.CHECKLIST_MAIN_TEMPLATE}`).prepend(checklistHeaderEle);

        let checklistDropdownWrapperEle = checklistHeaderEle?.querySelector(`${ClassMapConstanst.CHECKLIST_DROPDOWN_WRAPPER}`);
        let stageDropdwonWrapperEle = checklistHeaderEle?.querySelector(`${ClassMapConstanst.STAGE_DRP_WRAPPER}`);
        let triggerDropdownWrapperEle = checklistHeaderEle?.querySelector(`${ClassMapConstanst.TRIGGER_CHECKLIST_DROPDOWN_WRAPPER}`);

        if (primaryChecklist?.length > 0) {
            let primaryChecklistDropdownEle: any = getHTML(RenderEachPrimaryChecklistItem, { hostInstance: hostInstance, primaryChecklists: primaryChecklist, allChecklists: prevCheckListsData.checklists }, hostInstance);
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, primaryChecklistDropdownEle, { event: SDK_EVENTS.PLAYBOOK_PRIMARYLIST_TEMPLATE,  data : {checklists : prevCheckListsData.checklists, primaryChecklist}});
            checklistHeaderEle?.querySelector(`${ClassMapConstanst.CHECKLIST_DROPDOWN}`).append(primaryChecklistDropdownEle);
        }

        if (dynamicChecklist?.length > 0) {
            let dynamicChecklistDropdownEle: any = getHTML(RenderEachDynamicChecklistItem, { hostInstance: hostInstance, dynamicChecklists: dynamicChecklist, allChecklists: prevCheckListsData.checklists }, hostInstance);
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, dynamicChecklistDropdownEle, { event: SDK_EVENTS.PLAYBOOK_DYNAMICLIST_TEMPLATE,  data : {checklists : prevCheckListsData.checklists, dynamicChecklist}});
            checklistHeaderEle?.querySelector(`${ClassMapConstanst.CHECKLIST_DROPDOWN}`).append(dynamicChecklistDropdownEle);
        }

        if (primaryChecklist?.length || dynamicChecklist?.length) {
            checklistDropdownWrapperEle?.classList?.remove(ClassMapConstanst.HIDE_ELEMENT);
            prevCheckListsData?.checklists.map((cl: any, clInx: number) => {
                let clsName = cl.type === 'primary' ? ClassMapConstanst.PRIMARY_CHECKLIST_BTN : ClassMapConstanst.DYNAMIC_CHECKLIST_BTN;
                hostInstance.eventManager?.addEventListener(`${clsName}${clInx}`, 'click', () => {
                    checklistDropdownWrapperEle?.classList?.remove('show');
                    handleChecklistClickEvent(prevCheckListsData, cl);
                }, checklistHeaderEle);
            })
        }

        hostInstance.eventManager?.addEventListener(ClassMapConstanst.SELECTED_CHECKLIST_ARROW, 'click', () => {
            event?.stopPropagation();
            checklistDropdownWrapperEle?.classList?.toggle('show');
        }, checklistDropdownWrapperEle);

        hostInstance.eventManager?.addEventListener(ClassMapConstanst.SELECTED_STAGE_ARROW, 'click', () => {
            event?.stopPropagation();
            stageDropdwonWrapperEle?.classList?.toggle('show');
        }, stageDropdwonWrapperEle);

        hostInstance.eventManager?.addEventListener(ClassMapConstanst.TRIGGER_CHECKLIST_COUNT_BTN, 'click', () => {
            event?.stopPropagation();
            triggerDropdownWrapperEle?.classList?.toggle('show');
        }, checklistHeaderEle)
    }

    // open primary checklist bydefault if present.
    const sendOpenCheckListEvent = (primaryClList: any, dynamicClist: any) => {
        let checkListHeaderEle: any = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.CHECKLIST_HEADER}`);
        if (primaryClList?.length > 0) {
            let channel = rootServiceInstance.connectionDetails.channel;
            if (primaryClList[0]?.channels?.includes(channel)) {
                rootServiceInstance.proceedToClose = true;
                getCheckListIndex(primaryClList[0]);
                handleProceedToCloseBtn(checkListHeaderEle, true, true);
            }
        } else if (dynamicClist?.length > 0) {
            let bodyTemplate = hostInstance?.chatEle?.querySelector(`#${IdMapConstant.CHECKLIST_BODY_TEMPLATE}`);
            let checklistEmptyMsgEle = getHTML(RenderEmptyPlaybookMsg, { hostInstance: hostInstance }, hostInstance);
            if (bodyTemplate) {
                hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, checklistEmptyMsgEle, { event: SDK_EVENTS.PLAYBOOK_EMPTY_TEMPLATE,  data : {primaryClList, dynamicClist}});
                bodyTemplate.append(checklistEmptyMsgEle);
            }
            updateChecklistName(checkListHeaderEle, `${languageData?.PLAYBOOK_EMPTY_MSG}`, -1);
        }
    }

    const proceedToCloseButtonClick = (sendEvent = false) => {
        let obj = {
            stageId: '',
            id: ''
        };
        setAllCheckListData((prevCheckListsData: any) => {
            prevCheckListsData.checklists.forEach((item: any, index: number) => {
                if (item.type === 'primary') {
                    updateResumeBtnStatus(prevCheckListsData.checklists, index);
                    obj['stageId'] = item.stages[1]._id;
                    obj['id'] = item._id;
                    rootServiceInstance.selCLInx = index;
                    rootServiceInstance.selStInx = 1;
                    rootServiceInstance.isProceedToClose = true;
                    rootServiceInstance.selectNextStep(prevCheckListsData, index, 1, hostInstance);
                    let checkListHeaderEle: any = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.CHECKLIST_HEADER}`);
                    updateChecklistName(checkListHeaderEle, item.name, index);
                    prepareAndUpdateStageDropdown(checkListHeaderEle, item?.stages, 1);
                    updateChecklistBodyTemplate(prevCheckListsData, rootServiceInstance.selCLInx);
                    updateStepNumberInfo();
                }
            });
            if(sendEvent){
                let checklistParams: any = rootServiceInstance.prepareChecklistPayload(EVENTS.checklist_proceed_to_closed, prevCheckListsData, obj);
                emitEvents(EVENTS.checklist_proceed_to_closed, checklistParams, SDK_EVENTS.PLAYBOOK_PROCEED_TO_CLOSE_EVENT);
            }
            return prevCheckListsData
        });
    }

    const handleProceedToCloseBtn = (checklistHeaderEle: any, show: boolean, clickEvent: boolean) => {
        let proceedToClostBtn = checklistHeaderEle?.querySelector(`${ClassMapConstanst.PROCEEDTOCLOSE_BTN}`);
        if (show) {
            proceedToClostBtn?.classList.remove(ClassMapConstanst.HIDE_ELEMENT);
        } else {
            proceedToClostBtn?.classList.add(ClassMapConstanst.HIDE_ELEMENT);
        }
        if (clickEvent) {
            hostInstance.eventManager?.addEventListener(ClassMapConstanst.PROCEEDTOCLOSE_BTN, 'click', (e: any) => {
                handleCloseStage(true, proceedToClostBtn);
            }, checklistHeaderEle)
        }
    }

    const handleCloseStage = (flag : boolean, proceedToClostBtn : any) =>{
        proceedToCloseButtonClick(flag);
        proceedToClostBtn.classList.add(ClassMapConstanst.HIDE_ELEMENT);

        hostInstance?.chatEle?.querySelector(ClassMapConstanst.CHECKLIST_CLOSE_STAGE)?.classList?.remove(ClassMapConstanst.HIDE_ELEMENT);
        hostInstance?.chatEle?.querySelectorAll(ClassMapConstanst.CHECKLIST_CLOSE_STEPS)?.forEach((el: any) => el?.classList?.remove(ClassMapConstanst.HIDE_ELEMENT));
    }
    // end of proceed to close btn logic

    //checklist related logic (resume and update checklist);
    const getCheckListIndex = (clT: any) => {
        setAllCheckListData((prevCheckListsData: any) => {
            let index = prevCheckListsData?.checklists?.findIndex((obj: any) => obj._id == clT._id);
            if (index >= 0) {
                updateCheckList(prevCheckListsData, index);

                updateChecklistBodyTemplate(prevCheckListsData, index)

                if (!prevCheckListsData.checklists[index].openedChecklist) {
                    prevCheckListsData.checklists[index].openedChecklist = true;
                    let checklistParams: any = rootServiceInstance.prepareChecklistPayload(EVENTS.checklist_opened, prevCheckListsData, { "id": clT._id });
                    emitEvents(EVENTS.checklist_opened, checklistParams, SDK_EVENTS.PLAYBOOK_OPENED_EVENT);
                }
                updateStepNumberInfo();
            }
            return prevCheckListsData;
        });
    }

    const updateCheckList = (prevCheckListsData: any, clInx: number) => {
        let checklists = prevCheckListsData.checklists;

        let selStInx = checklists[clInx]?.stages?.length ? 0 : -1;

        rootServiceInstance.selCLInx = clInx;
        rootServiceInstance.selStInx = selStInx;

        if (checklists[clInx]?.stages[selStInx]?.steps[0]) {
            checklists[clInx].stages[selStInx].steps[0].ongoing = true;
            rootServiceInstance.selSpInx = 0;
            let stepId = checklists[clInx].stages[selStInx].steps[0]._id;
            rootServiceInstance.scrollView(stepId, hostInstance);
        }
        let checkListHeaderEle: any = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.CHECKLIST_HEADER}`);
        updateChecklistName(checkListHeaderEle, checklists[clInx].name, clInx);
        prepareAndUpdateStageDropdown(checkListHeaderEle, checklists[clInx]?.stages, selStInx);
    }

    const updateChecklistName = (checkListHeaderEle: any, name: string, clInx: number) => {
        let selectedChecklistSpan = checkListHeaderEle?.querySelector(`${ClassMapConstanst.SELECTED_CHECKLIST}`);
        if (selectedChecklistSpan) {
            selectedChecklistSpan.innerText = name;
        }
        checkListHeaderEle?.querySelector(`${ClassMapConstanst.CHECKLIST_ITEM_CHECK}${clInx}`)?.classList?.remove(ClassMapConstanst.HIDE_ELEMENT);
    }

    const updateChecklistBodyTemplate = (prevCheckListsData: any, index: number) => {
        let bodyTemplate = hostInstance?.chatEle?.querySelector(`#${IdMapConstant.CHECKLIST_STEP_TEMPLATE}`);
        let checklistBodyEle = getHTML(RenderChecklistBody, { hostInstance: hostInstance, stages: prevCheckListsData.checklists[index]?.stages, colors: PlaybookColorMap }, hostInstance);
        if (bodyTemplate) {
            bodyTemplate.innerHTML = '';
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, checklistBodyEle, { event: SDK_EVENTS.PLAYBOOK_BODY_TEMPLATE,  data : {stages: prevCheckListsData.checklists[index]?.stages, colors: PlaybookColorMap}});
            bodyTemplate.append(checklistBodyEle);
        }
        if (checklistBodyEle) {
            handleStepClickEvents(checklistBodyEle, prevCheckListsData, index);
        }
    }

    const handleChecklistClickEvent = (prevCheckListsData: any, clT: any) => {
        let index = prevCheckListsData.checklists.findIndex((obj: any) => obj._id == clT._id);
        if (prevCheckListsData.checklists[index]) {
            resumeAndUpdateCheckList(index);
        }
    }

    const resumeAndUpdateCheckList = (i: number) => {
        setAllCheckListData((prevCheckListsData: any) => {
            let checklists = prevCheckListsData.checklists;
            updateResumeBtnStatus(checklists, i);
            if (!checklists[i].openedChecklist) {
                getCheckListIndex(checklists[i])
            } else if (checklists[i].name != checklists[rootServiceInstance.selCLInx].name) {
                rootServiceInstance.selCLInx = i;
                rootServiceInstance.selStInx = 0;
                checkListResume(prevCheckListsData, i, 0);
                rootServiceInstance.selectNextStage(prevCheckListsData, i, 0, hostInstance);
                updateStepNumberInfo();
            }
            checkAndHideEmptyMsg();
            return prevCheckListsData;
        })
    }

    const updateResumeBtnStatus = (checklists: any, currentClIndex: number) => {
        let prevCLIndex = rootServiceInstance.selCLInx;
        if (currentClIndex != prevCLIndex && !checklists[prevCLIndex]?.completed && checklists[prevCLIndex]?.openedChecklist) {
            hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.CHECKLIST_EACH_RESUME}${prevCLIndex}`)?.classList.remove(ClassMapConstanst.HIDE_ELEMENT);
            hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.CHECKLIST_ITEM_CHECK}${prevCLIndex}`)?.classList.add(ClassMapConstanst.HIDE_ELEMENT);
        } else if(currentClIndex != prevCLIndex && checklists[prevCLIndex]?.completed){
            hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.CHECKLIST_ITEM_CHECK}${prevCLIndex}`)?.classList.add(ClassMapConstanst.HIDE_ELEMENT);
        }
        let currentResumeBtn = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.CHECKLIST_EACH_RESUME}${currentClIndex}`);
        if (!currentResumeBtn?.classList?.contains(ClassMapConstanst.HIDE_ELEMENT)) {
            currentResumeBtn?.classList?.add(ClassMapConstanst.HIDE_ELEMENT);
        }
    }

    const checkListResume = (prevCheckListsData: any, i: any, stInx: number) => {
        rootServiceInstance.isProceedToClose = false;
        let checkListHeaderEle: any = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.CHECKLIST_HEADER}`);
        updateChecklistName(checkListHeaderEle, prevCheckListsData.checklists[i].name, i);
        prepareAndUpdateStageDropdown(checkListHeaderEle, prevCheckListsData.checklists[i]?.stages, stInx);
        updateChecklistBodyTemplate(prevCheckListsData, i);
        let cl = prevCheckListsData.checklists[i];
        rootServiceInstance.showProceedToCloseBtn(hostInstance);
        let checklistParams: any = rootServiceInstance.prepareChecklistPayload(EVENTS.checklist_resume, prevCheckListsData, { "id": cl._id });
        emitEvents(EVENTS.checklist_resume, checklistParams, SDK_EVENTS.PLAYBOOK_RESUME_EVENT);
    }
    // end of checklist logic


    // stage related logic (stage selection)
    const prepareAndUpdateStageDropdown = (checkListHeaderEle: any, stageList: any, stageInx: number) => {
        let stageName = stageList[stageInx].name;
        let stageDropdownWrapper = checkListHeaderEle?.querySelector(`${ClassMapConstanst.STAGE_DRP_WRAPPER_MAIN}`);
        let selectedStageSpan = checkListHeaderEle?.querySelector(`${ClassMapConstanst.SELECTED_STAGE}`);
        let stageDropdown = checkListHeaderEle?.querySelector(`${ClassMapConstanst.STAGE_DROPDOWN}`);
        stageDropdownWrapper?.classList?.remove(ClassMapConstanst.HIDE_ELEMENT);
        if (selectedStageSpan) {            
            selectedStageSpan.innerText = stageName;
        }
        let stageDropdownEle: any = getHTML(RenderEachStageItem, { hostInstance: hostInstance, stageList: stageList, selectedStInx: stageInx, isProceedToClose: rootServiceInstance.isProceedToClose }, hostInstance);
        if (stageDropdownEle) {
            stageDropdown.innerHTML = '';
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, stageDropdownEle, { event: SDK_EVENTS.PLAYBOOK_STAGE_DROPDOWN_TEMPLATE,  data : {stageList: stageList, selectedStInx: stageInx, isProceedToClose: rootServiceInstance.isProceedToClose}});
            stageDropdown.append(stageDropdownEle);
        }
        let stageDropdownIcon = checkListHeaderEle?.querySelector(`${ClassMapConstanst.SELECTED_STAGE_ARROW}`);
        if (stageDropdownIcon) {
            stageList?.length <= 1 ? stageDropdownIcon.classList.add(ClassMapConstanst.HIDE_ELEMENT) : stageDropdownIcon.classList.remove(ClassMapConstanst.HIDE_ELEMENT)
        }

        if (rootServiceInstance.isProceedToClose) {
            stageDropdownEle.querySelector(`${ClassMapConstanst.CHECKLIST_CLOSE_STAGE_BTN}`)?.classList?.remove(ClassMapConstanst.CHECKLIST_DISABLE_MSG);
        }

        stageList?.map((stage: any, stInx: number) => {
            hostInstance.eventManager?.addEventListener(`${ClassMapConstanst.CHECKLIST_EACH_STAGE_DRP_ITEM}${stInx}`, 'click', () => {
                rootServiceInstance.selStInx = stInx;
                updateStepNumberInfo();
                handleStageDropdownClickEvent(stageDropdownEle, stInx, stageList);
            }, stageDropdownEle);
        });

        setAllCheckListData((prevCheckListData : any) => {
            let checklists = prevCheckListData.checklists;
            if (!(checklists[rootServiceInstance.selCLInx]?.type == 'primary' && checklists[rootServiceInstance.selCLInx].stages[rootServiceInstance.selStInx].name == 'Close')) {
                rootServiceInstance.isProceedToClose = false;
                rootServiceInstance.showProceedToCloseBtn(hostInstance);
            }
            return prevCheckListData
        })

      
      
    }

    const handleStageDropdownClickEvent = (stageDropdownEle: any, stInx: number, stageList: any) => {
        rootServiceInstance.handleStageCheck(stageDropdownEle, stInx, stageList, hostInstance);
        setAllCheckListData((prevCheckListsData: any) => {
            rootServiceInstance.selectStage(prevCheckListsData, rootServiceInstance.selCLInx, stInx, hostInstance);
            return prevCheckListsData;
        })
    }

    // end of stage selection logic.

    // step related logic (step selection, step ongoing, step complete etc...)
    const handleStepClickEvents = (currentChecklistEle: any, prevCheckListsData: any, clIndex: number) => {
        prevCheckListsData.checklists[clIndex]?.stages?.map((stage: any, stInx: number) => {

            stage?.steps?.map((step: any, stepInx: number) => {

                let eachPlaybookStep = currentChecklistEle?.querySelector(`${ClassMapConstanst.CHECKLIST_EACH_STEP}${stInx}-${stepInx}`);

                hostInstance.eventManager?.addEventListener(`${ClassMapConstanst.CHECKLIST_EACH_STEP}${stInx}-${stepInx}`, 'click', (e: any) => {
                    if (!step.complete) {
                        setAllCheckListData((prevCheckListsData: any) => {
                            rootServiceInstance.clickStep(prevCheckListsData, stInx, step, stepInx, hostInstance);
                            return prevCheckListsData;
                        })
                    }
                }, currentChecklistEle);

                hostInstance.eventManager?.addEventListener(`${ClassMapConstanst.CHECKLIST_STEP_COMPLETE_BTN}${stInx}-${stepInx}`, 'click', (e: any) => {
                    e.stopPropagation();
                    if (!step.complete) {
                        setAllCheckListData((prevCheckListsData: any) => {
                            stepComplete(prevCheckListsData, stage, step, clIndex, stInx, stepInx);
                            return prevCheckListsData;
                        })
                    }
                }, currentChecklistEle);

                hostInstance.eventManager?.addEventListener(ClassMapConstanst.CHECKLIST_STEP_COPY_BTN, 'click', () => {
                    rootServiceInstance.sendAndCopyForPlaybook(ProjConstants.COPY_METHOD, step.description, eachPlaybookStep, hostInstance);
                    stepComplete(prevCheckListsData, stage, step, clIndex, stInx, stepInx);
                }, eachPlaybookStep);

                hostInstance.eventManager?.addEventListener(ClassMapConstanst.CHECKLIST_STEP_SEND_BTN, 'click', () => {
                    rootServiceInstance.sendAndCopyForPlaybook(ProjConstants.SEND_METHOD, step.description, eachPlaybookStep, hostInstance);
                    stepComplete(prevCheckListsData, stage, step, clIndex, stInx, stepInx);
                }, eachPlaybookStep);

                step.confirmButtons?.map((btn: any, btnInx: number) => {
                    hostInstance.eventManager?.addEventListener(`${ClassMapConstanst.CHECKLIST_STEP_CONFIRMATION_BTN}${btnInx}`, 'click', () => {                        
                        stepComplete(prevCheckListsData, stage, step, clIndex, stInx, stepInx);
                        rootServiceInstance.confirmationBtnForPlaybook(btn, eachPlaybookStep, hostInstance);
                    }, eachPlaybookStep);
                });

            })
        })
    }

    const updateStepNumberInfo = () => {
        setAllCheckListData((prevCheckListsData : any) =>{
            let totalSteps = prevCheckListsData.checklists[rootServiceInstance.selCLInx]?.stages[rootServiceInstance.selStInx]?.steps?.length;
            let completedSteps = rootServiceInstance.getNumberstepCompInStage(prevCheckListsData);
            let totalStepCountEle = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.STEP_COMPLETE_COUNT}`);
            if(totalStepCountEle){
                totalStepCountEle.classList.remove(ClassMapConstanst.HIDE_ELEMENT);
                totalStepCountEle.innerText = completedSteps + '/' + totalSteps;
            }
            return prevCheckListsData;
        })
    }

    const stepComplete = (prevCheckListsData: any, stage: any, step: any, clIndex: number, stInx: number, stepInx: number) => {
        let id = prevCheckListsData.checklists[clIndex]._id;
        let stageId = stage._id;
        let stepId = step._id;
        step.ongoing = false;
        step.complete = true;
        let checklistParams: any = rootServiceInstance.prepareChecklistPayload(EVENTS.checklist_step_closed, prevCheckListsData,
            {
                id,
                stageId,
                stepId,
                "adheredBy": "manual" // coachingEngine / manual
            },
            true);
        emitEvents(EVENTS.checklist_step_closed, checklistParams, SDK_EVENTS.PLAYBOOK_STEP_CLOSED_EVENT);
        setAllCheckListData((prevCheckListsData: any) => {
            updateStepNumberInfo();
            rootServiceInstance.selectNextStage(prevCheckListsData, clIndex, stInx, hostInstance);
            rootServiceInstance.checkAllStagesCompleted(prevCheckListsData, id, hostInstance);
            return prevCheckListsData;
        })
    }
    // end of step logic

    //trigger dynamic checklist
    const updateTriggerChecklistCount = (triggeredCheckLists : any) => {
        let checklistCountEle = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.TRIGGER_CHECKLIST_BULB_COUNT}`);
        if(checklistCountEle){
            checklistCountEle.innerText = triggeredCheckLists?.length;
        }
    }

    const addTriggerChecklistItem = (checklist : any, triggerChecklistIndex : number) => {        
        let triggerChecklistDropdownContainer = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.TRIGGET_CHECKLIST_DROPDOWN}`);
        let checklistItem = getHTML(RenderEachTriggeredChecklist, {hostInstance : hostInstance, checklist : checklist}, hostInstance);
        if(checklistItem && triggerChecklistDropdownContainer){
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, checklistItem, { event: SDK_EVENTS.PLAYBOOK_TRIGGERED_LIST_TEMPLATE,  data : {checklist}});
            triggerChecklistDropdownContainer.append(checklistItem);
            hostInstance.eventManager?.addEventListener(`${ClassMapConstanst.TRIGGER_CHECKLIST_BTN}${checklist?._id}`, 'click', () => {
                setAllCheckListData((prevCheckListsData : any)=> {
                    selectDynCl (prevCheckListsData, checklist, triggerChecklistIndex);
                    return prevCheckListsData;
                })
                
            }, triggerChecklistDropdownContainer);
        }
    }

    const selectDynCl = (prevCheckListsData: any, clT: any, i: number) => {
        setTriggeredDynCheckLists((prevTriggetDynChecklists: any) => {
            removeTriggeredChecklistItem(prevTriggetDynChecklists[i], i);
            let triggeredDynCheckLists = prevTriggetDynChecklists.slice(0, i).concat(prevTriggetDynChecklists.slice(i + 1));
            return triggeredDynCheckLists;
        })
        let index = prevCheckListsData.checklists.findIndex((obj: any) => obj._id == clT._id);
        if (prevCheckListsData.checklists[index]) {
            resumeAndUpdateCheckList(index);
        }
    }

    const removeTriggeredChecklistItem = (checklistItem : any, i : number) => {
        let triggerChecklistDropdownContainer = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.TRIGGET_CHECKLIST_DROPDOWN}`);
        let triggerDropdownWrapperEle = hostInstance?.chatEle?.querySelector(`${ClassMapConstanst.TRIGGER_CHECKLIST_DROPDOWN_WRAPPER}`);
        let checklistEle = triggerChecklistDropdownContainer.querySelector(`${ClassMapConstanst.TRIGGER_CHECKLIST_BTN}${checklistItem._id}`);
        if(checklistEle){
            checklistEle?.remove();
            triggerDropdownWrapperEle?.classList?.toggle('show');
        }
    }

    return (
        <div className="playbook-wrapper-template">
            <div className="playbook-template-data" id="checkListMainTemplate">
                <div className="playbook-wrapper-body" id="checkListBodyTemplate">
                    <div className="playbook-steps-info" id="checklistStepTemplate">

                    </div>
                </div>
            </div>
        </div>
    );
}
